import SliderViewSection from "../../components/SliderViewSection";
import {
    slideImg,
    Enterpriser1,
    Enterpriser2,
    Enterpriser3,
    Enterpriser4,
    Enterpriser5,
    Enterpriser6,
    Component1,
  Component2,
  Component3,
  Component4,
  Component5,
  Component6,
} from "../../constant";
import ContactUs from "../../components/ContactUs";
import StayInLoop from "../../components/StayInLoop";
import SolutionFourCardSwapSection from "../../components/SolutionFourCardSwapSection";
import WeAreIED from "../../components/WeAreIED";
import HeroAboutVideo from "../../components/HeroAboutVideo";
import GraphViewSection from "../../components/GraphViewSection";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutline";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import RiskManagementLanding from "../../components/Solution/RiskManagementLanding";
import TogetherSection from "../../components/Solution/TogetherChange";

const slidesData = [
    {
        viewData: [
            {
                imgUrl: [Component1],
                highlights: [
                    "Centralized enterprise-wide risk visibility through integrated dashboards and heatmaps",
                    "Real-time monitoring of key risk indicators (KRIs), incidents, and control effectiveness",
                    "AI-driven analytics for identifying emerging risks and operational vulnerabilities",
                    "Integrated governance, compliance, and mitigation tracking workflows",
                    "Executive-level reporting with actionable insights and enterprise risk scorecards",
                    "Scalable integration with ERP, audit, compliance, and operational systems"
                ],
            },
            {
                imgUrl: [Component2],
            },

            {
                imgUrl: [Component3],
            },
            {
                imgUrl: [Component4],
            },
            {
                imgUrl: [Component5],
            },
            {
                imgUrl: [Component6],
            }
           
        ],
        
 
        menuItems: [{
            title: " Risk Universe",
            Icons: HomeOutlinedIcon,
        },
        {
            title: "Risk Maps",
            Icons: PeopleOutlineOutlinedIcon,
        },
        {
            title: "Mitigation Control",
            Icons: DashboardOutlinedIcon,
        },
        {
            title: "Dashbaords",
            Icons: HomeOutlinedIcon,
        },
        {
            title: "Taxonomy",
            Icons: PeopleOutlineOutlinedIcon,
        },
        {
            title: "Risk Owners",
            Icons: InsertChartOutlinedIcon,
        }
       ],
    }


];

const SliderData = [
    {
        maintitle: "Empowering Enterprise Risk Management with Connected Intelligence",
        subtitle: "Establish a centralized risk intelligence framework that connects operational, financial, compliance, cyber and strategic risks into a unified enterprise-wide view.",
        title: "Connected Risk Visibility",
        para: "Break organizational silos and create a unified risk intelligence ecosystem powered by data-driven governance",
        hightlights: [
            "Unified enterprise risk visibility across business functions",
            "Real-time risk monitoring and centralized governance dashboards",
            "Connected risk intelligence for identifying emerging risk patterns",
            "Integrated risk scoring and prioritization mechanisms",
        ],
        mediaUrl: Enterpriser1,
    },
    {
        maintitle: "Predict Risks Before They Impact Operations ",
        subtitle: "Leverage AI-driven analytics and predictive intelligence to identify operational anomalies, emerging threats and potential control failures proactively.",
        title: "Predictive Risk Intelligence",
        para: "Transform enterprise data into actionable risk insights for faster and smarter decision-making.",
        highlights: [
            "AI-powered anomaly detection and predictive risk analytics",
            "Early warning alerts for operational and compliance risks",
            "Trend analysis across incidents, audits, and controls",
            "Real-time risk forecasting using enterprise data models"
        ],
        mediaUrl: Enterpriser2
    },
    {
        maintitle: "Strengthen Governance Through Integrated Risk Frameworks",
        subtitle: "Align enterprise risks with governance structures, compliance obligations and internal control frameworks to improve organizational resilience and accountability.",
        title: "Governance-Driven Risk Management",
        para: "Transform enterprise data into actionable risk insights for faster and smarter decision-making.",
        highlights: [
            "Integrated governance, risk, and compliance management",
            "Alignment with COSO, ISO 31000, and enterprise control frameworks",
            "Centralized policy, audit, and compliance monitoring",
            "Automated risk-control mapping and assessment workflows"
        ],
        mediaUrl: Enterpriser3
    },
    {
        maintitle: "Predict Risks Before They Impact Operations ",
        subtitle: "Leverage AI-driven analytics and predictive intelligence to identify operational anomalies, emerging threats and potential control failures proactively.",
        title: "Predictive Risk Intelligence",
        para: "Transform enterprise data into actionable risk insights for faster and smarter decision-making.",
        highlights: [
            "Live monitoring of operational and enterprise risk indicators",
            "Real-time situational awareness across distributed operations",
            "Integrated alerts, escalation workflows, and incident tracking",
            "Cross-functional operational risk intelligence dashboards"
        ],
        mediaUrl: Enterpriser4
    },
    {
        maintitle: "Enable Smarter Decisions Through Risk Intelligence",
        subtitle: "Empower leadership teams with executive dashboards, enterprise KPIs and risk analytics that support strategic planning and proactive decision-making.",
        title: "Executive Risk Insights",
        para: "Deliver actionable intelligence to leadership through connected enterprise risk analytics. ",
        highlights: [
            "Executive-level enterprise risk dashboards and scorecards",
            "Real-time KPI and KRI monitoring across business functions",
            "Data-driven insights for strategic risk prioritization",
            "Enterprise-wide reporting and decision-support analytics"
        ],
        mediaUrl: Enterpriser5
    },
    {
        maintitle: "Build a Future-Ready Enterprise Risk Ecosystem",
        subtitle: "Deploy scalable risk intelligence platforms that integrate enterprise systems, operational data and governance workflows into a unified digital risk environment.",
        title: "Enterprise Risk Transformation",
        para: "Create a connected digital risk ecosystem for sustainable governance and operational resilience.",
        highlights: [
            "Scalable enterprise-wide risk intelligence architecture",
            "Integration with ERP, EHS, audit, and operational systems",
            "Centralized risk repositories and governance workflows",
            "AI-enabled continuous monitoring and enterprise resilience"
        ],
        mediaUrl: Enterpriser6
    }
];

const FourCardsSwapcardData = [
    {
        title: "Mitigation Tracking",
        subtitle: "Monitor mitigation plans, control effectiveness and risk treatment actions through centralized dashboards and automated risk workflows.",
        description:
            "Track enterprise-wide mitigation progress with real-time risk visibility",
    },
    {
        title: "Regulatory Compliance",
        subtitle: "Streamline compliance monitoring, policy adherence and regulatory reporting across governance frameworks and operational functions.",
        description: "Enable proactive compliance management with connected governance intelligence"
    },

    {
        title: "Risk Assessment & Prioritization",
        subtitle: "Identify, evaluate and prioritize enterprise risks using AI-driven scoring models, heatmaps and impact-based risk analytics.",
        description:
            "Strengthen decision-making through intelligent enterprise risk prioritization",
    },
];
const tabsData = [
    {
        label: "About iED",
        key: "1",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Mission",
        key: "2",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Leadership",
        key: "3",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Differentiators",
        key: "4",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Technology",
        key: "5",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
];


export default function EnterpriseRiskManagement() {
    return (
        <>
            <RiskManagementLanding />
            <SliderViewSection
                title={"Empowering Risk Management with Data-Driven Insights"}
                subTitle={"Our dashboard offers powerful tools like hindrance analytics, production tracking, and performance scorecards. Streamline operations, improve efficiency, and make informed decisions with ease."}
                data={SliderData}
            />
            <SolutionFourCardSwapSection
                title={"Stay Ahead of Risks, Stay Ahead in Business"}
                subTitle={"Enable proactive enterprise risk management through intelligent risk monitoring, governance-driven workflows and real-time risk intelligence designed for modern enterprises. Gain deeper visibility into operational, compliance, financial and strategic risks with connected analytics that support faster decisions, stronger governance and improved organizational resilience"}
                cardData={FourCardsSwapcardData}
            />
            <GraphViewSection
                title={"Dashboards Built for Intelligent Enterprise Risk Oversight"}
                subTitle={"Our enterprise risk management dashboards provide centralized visibility into operational, compliance, financial and strategic risks — enabling organizations to strengthen governance, improve resilience and make informed decisions in real time. Designed to support connected risk intelligence, the platform integrates enterprise data, risk controls, mitigation workflows and governance frameworks into a unified risk monitoring ecosystem. "}
                data={slidesData}
            />
            <WeAreIED />
            <HeroAboutVideo tabsData={tabsData} isNetzero={true} />
            <TogetherSection title={"Building Resilient Enterprises, Together"}
                subTitle={"We empower organizations with intelligent enterprise risk management solutions that transform data into actionable risk intelligence, enabling proactive governance and confident decision-making. From identifying emerging risks and monitoring compliance obligations to tracking mitigation actions and strengthening operational resilience, our connected risk intelligence platform helps enterprises stay prepared, protected and future-ready"}
            />
            <ContactUs />
            <StayInLoop />
        </>
    );
}
